/**
 * If user profile is incomplete, redirect to Complete Profile section.
 * @returns {Promise}
 */
export default function ({ store, redirect }) {
  if (store.state.user.user.incompleteProfile) {
    return redirect({ path: '/sign-up/complete-profile' });
  }

  return Promise.resolve(true);
}
